import styled from '@emotion/styled'
import { css } from '@emotion/react'

import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'

import Input from '@src/components/inputs/Input'
import SVGLoador from '@src/components/svg/SVGLoader'

type VariantOptionFormProps = {
	depth: number
}

const VariantOptionForm = ({ depth }: VariantOptionFormProps) => {
	const { getProductVariantsOptionsFormProps, getFieldProps } = useMyProductFormContext()
	const { variantOptionFields, appendVariantOption, removeVariantOption } =
		getProductVariantsOptionsFormProps()
	const optionsArr = variantOptionFields
		.map((field, index) => {
			return { ...field, index }
		})
		.filter((option) => {
			return option.variantDepth === depth
		})
	return (
		<VariantOptionBlock>
			{optionsArr.map((field, index) => {
				return (
					depth === field.variantDepth && (
						<VariantOptionInputBlock key={`variant-option-${field.id}`}>
							<InputStyle
								{...getFieldProps(`productVariantOptions.${field.index}.name`)}
								{...(index === 0 && { label: '세부 옵션 (ex. 무게, 사이즈 등)' })}
								placeholder="ex. 검정"
								css={inputStyle}
								wrapperStyle={wrapperStyle}
								labelStyle={labelStyle}
							/>
							<VariantOptionDeleteBtn
								type="button"
								onClick={() => {
									if (removeVariantOption) removeVariantOption(field.index)
								}}
							>
								<SVGLoador name="closeIcon" />
							</VariantOptionDeleteBtn>
						</VariantOptionInputBlock>
					)
				)
			})}
			<AddDetailOptionBtn
				type="button"
				onClick={() => {
					if (appendVariantOption) appendVariantOption(depth)
				}}
			>
				세부 옵션 추가
			</AddDetailOptionBtn>
		</VariantOptionBlock>
	)
}

const VariantOptionBlock = styled.div`
	display: flex;
	flex-direction: column;
`

const VariantOptionInputBlock = styled.div`
	position: relative;
	width: auto;
`
const InputStyle = styled(Input)`
	width: 25.8rem;
	padding-right: 2.5rem;
	&:nth-of-type(1) {
		margin-right: 5rem;
	}
`

const VariantOptionDeleteBtn = styled.button`
	position: absolute;
	bottom: 0;
	left: 23.8rem;
	display: flex;
	align-items: center;
	justify-content: center;
	transform: translateY(-180%);
	background: #fff;
	border: none;
	padding: 0;
	width: 1rem;
	height: 1rem;
`

const AddDetailOptionBtn = styled.button`
	width: 25.8rem;
	margin-top: 2.4rem;
	padding: 1.2rem 0;
	border: none;
	border-radius: 0.4rem;
	background-color: #ffcf19;
	font-size: 1.4rem;
	font-weight: 600;
	line-height: 1.7rem;
`
const wrapperStyle = css`
	flex-direction: column;
	width: auto;
`

const labelStyle = css`
	width: 100%;
`

const inputStyle = css``

export default VariantOptionForm
